import shopConfig, { type Language } from '@packages/config';

/** Checks if the given pathname contains one of the languages from the shop configuration */
export const pathnameHasLanguage = (pathname: string) =>
  shopConfig.i18n.languages.some(
    (lang: Language) => pathname.startsWith(`/${lang}/`) || pathname === `/${lang}`,
  );
